import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CardBasic from "../components/CardBasic";
import ModalLoading from "../components/ModalLoading";
import axios from "axios";
import { HEADER, GetBalance } from "../utils/Utils";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import ButtonRequire from "../components/Button/ButtonRequire";
import ModalPin from "../components/Modal/ModalPin";
import ModalInformation from "../components/Modal/ModalInformation";

export default function Withdraw() {
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));
  const { state } = useLocation();
  const { saldo, bankAccount } = state ?? {};
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [showModalLoading, setShowModalLoading] = useState(true);
  const [message, setMessage] = useState({
    message: "",
    type: "",
    isShow: false,
  });
  const [withdrawData, setWithdrawData] = useState(saldo);
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const [countPinTrial, setCountPinTrial] = useState(0);
  const [showModalPin, setShowModalPin] = useState(false);
  const [showModalInformation, setShowModalInformation] = useState(false);

  const ADMIN_FEE = 2000;

  useEffect(() => {
    async function setBalance() {
      setShowModalLoading(true);

      const balance = await GetBalance(dataOutlet.channel_id, null);
      setWithdrawData(balance);

      setShowModalLoading(false);
    }
    setBalance();
  }, []);

  const handleMessageError = (_message) => {
    setMessage({
      message: _message ?? "Sorry you failed to withdraw your balance",
      type: "error",
      isShow: true,
    });
    setShowModalLoading(false);
  };

  const WithdrawBalance = async (e) => {
    e.preventDefault();
    setShowModalLoading(true);
    // ADD UUID for post /mitra/ewalletTransaction
    let detail_data = {
      outlet_kartini_id: user.outlet_kartini_id,
      channel_id: dataOutlet.channel_id,
      nominal: parseInt(withdrawData.nominal),
      transaction_type: "Withdrawal", // (Deposit | Withdrawal | Redemption | )
      status: "pending", // (reject | pending | success)
      mitra_ewallet_id: uuidv4(),
      bank_account_id: bankAccount.bank_account_id,
      order_id: uuidv4(), // TODO: tihis should use code unique for tracking transactions
      description: `Withdrawal ${parseInt(withdrawData.nominal)} ${
        user.outlet_kartini_id
      }`,
      // platform: "xendit",
    };

    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL_API}/dompetKartiniPin?akuisisi_id=${user.akuisisi_id}`,
        {
          headers: HEADER,
        },
      )
      .then(async (res) => {
        if (!_.isEmpty(res.data.data)) {
          let dompet_kartini_pin_id = res.data.data[0].dompet_kartini_pin_id;
          let _pin = _.join(pin, "");
          let pin_verify = res.data.data[0].pin_code;
          if (_pin === pin_verify && res.data.data[0].pin_status === "active") {
            setShowModalPin(false);
            let balance;
            try {
              balance = await GetBalance(dataOutlet.channel_id, null);
              if (
                parseInt(detail_data.nominal) <=
                parseInt(balance.ewallet_balance)
              ) {
                await axios.post(
                  `${process.env.REACT_APP_BASE_URL_API}/mitra/ewalletTransaction`,
                  { ...detail_data, provider: "transfez" },
                  {
                    headers: HEADER,
                  },
                );
                await axios.post(
                  `${process.env.REACT_APP_BASE_URL_API}/mitra/ewalletOutletKartiniAsignment`,
                  {
                    outlet_kartini_id: user.outlet_kartini_id,
                    mitra_ewallet_id: detail_data.mitra_ewallet_id,
                    channel_id: dataOutlet.channel_id,
                  },
                  {
                    headers: HEADER,
                  },
                );
                detail_data = {
                  mitra_ewallet_id: detail_data.mitra_ewallet_id,
                  ewallet_balance:
                    parseInt(balance.ewallet_balance) -
                    parseInt(detail_data.nominal),
                  deposit_balance: parseInt(balance.deposit_balance),
                };
                await axios
                  .post(
                    `${process.env.REACT_APP_BASE_URL_API}/mitra/ewallet`,
                    detail_data,
                    {
                      headers: HEADER,
                    },
                  )
                  .then(() => {
                    // setMessage({
                    //    message:
                    //       "You have successfully withdrawn your balance, please allow 2x24 hours for the money to be sent to your account.",
                    //    type: "success",
                    //    isShow: true,
                    // });
                    setShowModalInformation(true);
                    setStep(step + 1);
                    setShowModalLoading(false);
                  });
              } else {
                setMessage({
                  message: "Sorry, your ewallet balance is insufficient",
                  type: "error",
                  isShow: true,
                });
              }
            } catch (error) {
              console.error(error);
              handleMessageError();
              return;
            }
          } else {
            let count_trial_pin = countPinTrial + 1;
            setCountPinTrial(count_trial_pin);
            if (count_trial_pin === 3) {
              axios
                .put(
                  `${process.env.REACT_APP_BASE_URL_API}/dompetKartiniPin/${dompet_kartini_pin_id}`,
                  {
                    dompet_kartini_pin_id: dompet_kartini_pin_id,
                    pin_code: pin_verify,
                    pin_status: "disable",
                    akuisisi_id: user.akuisisi_id,
                  },
                  { headers: HEADER },
                )
                .catch((error) => console.error(error));
              handleMessageError(
                "You have entered the wrong pin 3 times, for safety please contact kartini to be able to withdraw.",
              );
            } else if (res.data.data[0].pin_status === "disable") {
              handleMessageError(
                "Your pin is suspended because you have entered the wrong pin 3 times, for safety please contact kartini to be able to withdraw.",
              );
            } else {
              handleMessageError(
                "The PIN you entered is incorrect, try again.",
              );
            }
          }
        } else {
          handleMessageError(
            "You haven't created a pin, please contact kartini to be able to withdraw.",
          );
        }
      })
      .catch((error) => console.error(error));
  };

  const BannerMessage = () => {
    let color = "";
    var icon;
    switch (message.type) {
      case "success":
        color = "bg-green-100 text-green-600";
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="mr-1 inline h-5 w-5 flex-shrink-0"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        );
        break;
      case "error":
        color = "bg-red-100 text-red-600";
        icon = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="mr-1 inline h-5 w-5 flex-shrink-0"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
        );
        break;
      default:
        break;
    }

    return (
      <div className="mt-5">
        <div className={`${color} flex rounded px-3 py-2`}>
          <div>{icon}</div>
          <div className="mt-0.5 text-sm">{message.message}</div>
        </div>
      </div>
    );
  };

  /* Fungsi */
  function formatRupiah(angka, prefix) {
    angka = typeof angka === "string" ? angka : angka.toString();
    var number_string = angka.replace(/[^,\d]/g, "").toString(),
      split = number_string.split(","),
      sisa = split[0].length % 3,
      rupiah = split[0].substr(0, sisa),
      ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
    return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
  }

  return (
    <>
      {_.isEmpty(user) || _.isEmpty(dataOutlet) ? (
        <Navigate to="/signin" />
      ) : !bankAccount ? (
        <Navigate to="/" />
      ) : (
        <>
          <ModalInformation
            showModal={showModalInformation}
            setShowModal={setShowModalInformation}
            type="success"
            title="Permintaan Withdrawal diterima"
            detail="Kami telah menerima permintaan withdrawal (penarikan dana) Anda. Proses penarikan dana membutuhkan waktu 2 (dua) hari kerja. Anda dapat memantau prosesnya pada confirmation status withdrawal pada menu E-Wallet. Terima kasih atas partisipasi Anda sebagai Mitra Kartini."
          />
          <ModalPin
            showModal={showModalPin}
            setShowModal={setShowModalPin}
            pin={pin}
            setPin={setPin}
            functionOnClick={WithdrawBalance}
            message={message}
          />
          <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
          />
          <div className="flex items-center justify-between px-5 pt-5">
            <div>
              {step < 3 && (
                <button
                  className="btn text-gray-600 hover:border-gray-300"
                  onClick={() => (step == 1 ? navigate(-1) : setStep(step - 1))}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                    />
                  </svg>
                  <span className="ml-2">Back</span>
                </button>
              )}
            </div>
            <div className="flex items-center justify-center">
              <div
                className={`px-1.5 ${
                  step >= 1
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
                onClick={() => setStep(1)}
              >
                1
              </div>
              <div
                className={`h-1 w-6 ${
                  step >= 1 ? "bg-indigo-500" : "bg-gray-200"
                } `}
              ></div>
              <div
                className={`px-1.5 ${
                  step >= 2
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                2
              </div>
              <div
                className={`h-1 w-6 ${
                  step >= 2 ? "bg-indigo-500" : "bg-gray-200"
                }`}
              ></div>
              <div
                className={`px-1.5 ${
                  step === 3
                    ? "bg-indigo-500 text-white"
                    : "bg-gray-200 text-gray-500"
                } rounded-full text-sm`}
              >
                3
              </div>
            </div>
          </div>
          <div className="space-y-5 px-5 py-5">
            <CardBasic title="Receiving Bank">
              <div className="px-5 pb-1 pt-4">
                <div className="space-y-3">
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Bank Name
                    </div>
                    <p className="text-gray-500">
                      {bankAccount.bank_name ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Account Number
                    </div>
                    <p className="text-gray-500">
                      {bankAccount.bank_number ?? "-"}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-800">
                      Account Owner Name
                    </div>
                    <p className="text-gray-500">
                      {bankAccount.holder_name ?? "-"}
                    </p>
                  </div>
                </div>
              </div>
            </CardBasic>
            {/* step 2 */}
            {step > 1 && (
              <>
                <CardBasic title="Withdraw Details">
                  <div className="px-5 pb-1 pt-4">
                    <div className="space-y-3">
                      <div className="text-sm">
                        <div className="mb-1 font-medium text-gray-700">
                          Withdraw Details
                        </div>
                        <div className="flex items-center justify-between">
                          <p className="text-gray-500">Total Withdrawal</p>
                          <p className="text-gray-500">
                            {formatRupiah(
                              withdrawData.nominal.toString(),
                              "Rp. ",
                            )}
                          </p>
                        </div>
                        <div className="flex items-center justify-between">
                          <p className="text-gray-500">Admin Fee</p>
                          <p className="text-gray-500">
                            - {formatRupiah(ADMIN_FEE.toString(), "Rp. ")}
                          </p>
                        </div>
                      </div>
                      <hr />
                      <div className="text-sm">
                        <div className="flex items-center justify-between">
                          <div className="font-medium text-gray-700">
                            Total Received
                          </div>
                          <p className="text-lg font-semibold text-gray-900">
                            {formatRupiah(
                              (
                                parseInt(withdrawData.nominal) - ADMIN_FEE
                              ).toString(),
                              "Rp. ",
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBasic>
              </>
            )}
            {step === 1 && (
              <>
                <div className="text-sm">
                  <div className="mb-1 font-medium text-gray-700">
                    Enter Amount
                  </div>
                  <input
                    name="nominal"
                    placeholder="Rp. 0"
                    className={`form-input mb-0.5 mt-1.5 h-12 w-full font-semibold ${
                      withdrawData.nominal > withdrawData.ewallet_balance &&
                      "border-2 border-red-500"
                    }`}
                    type="text"
                    value={
                      withdrawData.nominal
                        ? formatRupiah(withdrawData.nominal.toString(), "Rp. ")
                        : ""
                    }
                    onChange={(e) => {
                      let value = _.isEmpty(
                        e.target.value.replace(/[^\d]/g, ""),
                      )
                        ? 0
                        : e.target.value.replace(/[^\d]/g, "");
                      if (
                        parseInt(value) <=
                        parseInt(withdrawData.ewallet_balance)
                      ) {
                        setWithdrawData((prevState) => ({
                          ...prevState,
                          nominal: value,
                        }));
                      }
                    }}
                  />
                  <div className="mt-2 flex items-center justify-between">
                    <span className="text-xs font-medium text-gray-400">
                      Balance:{" "}
                      {formatRupiah(
                        withdrawData.ewallet_balance.toString(),
                        "Rp. ",
                      )}
                    </span>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        onChange={(e) =>
                          setWithdrawData((prevState) => ({
                            ...prevState,
                            nominal:
                              e.target.checked && withdrawData.ewallet_balance,
                          }))
                        }
                        disabled={showModalLoading}
                      />
                      <span className="ml-1 text-xs font-medium text-gray-400">
                        {showModalLoading
                          ? "Please Wait..."
                          : "Take All Balance"}
                      </span>
                    </label>
                  </div>
                </div>
              </>
            )}
            {step >= 2 && message.isShow && BannerMessage()}
            <div className="mt-6 flex flex-col space-y-2">
              <ButtonRequire
                title={
                  showModalLoading
                    ? "Please Wait..."
                    : step === 1
                      ? "WITHDRAW"
                      : step === 2
                        ? "CONFIRM WITHDRAW"
                        : step === 3 && "BACK TO HOME"
                }
                functionOnClick={() => {
                  if (step === 3) {
                    navigate(-1);
                  } else if (step === 2) {
                    setShowModalPin(true);
                    // await WithdrawBalance();
                  } else {
                    setStep(step + 1);
                  }
                }}
                isDisabled={
                  !withdrawData.nominal ||
                  parseInt(withdrawData.nominal) === 0 ||
                  parseInt(withdrawData.nominal) >
                    parseInt(withdrawData.ewallet_balance) ||
                  parseInt(withdrawData.ewallet_balance) === 0 ||
                  showModalLoading
                }
              />
              {step !== 3 && (
                <button
                  className="btn-lg w-full bg-gray-200 text-black hover:bg-gray-300"
                  onClick={() => navigate(-1)}
                  //   to="/confirm-outlet"
                >
                  CANCEL
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
